export default {
  name: 'GoodsCardDesc',

  parent: 'GoodsCard',

  render () {
    return (
      <div class="desc-container">
        <p>我是标题</p>
        <p>我是内容我是内容我是内容我是内容我是内容我是内容</p>
      </div>
    )
  }
}